import React, { Component } from "react";
import _ from "lodash";

export interface InputProps {
    field?: any;
    form?: any;
    inputtype?: string;
    placeholder?: string;
    givenid?: string;
    disabled?: boolean;
    decimal?: boolean;
    isConfig?: boolean;
}

export interface InputState {
    values?: any;
}


export default class BaseNumbersArray extends Component<InputProps, InputState> {

    constructor(props) {
        super(props);

        this.state = {
            values: _.cloneDeep(this.props.field.value).map((item, index) => {
                return {
                    ...item,
                    order: index,
                    index: index
                }
            })
        }
    }

    setFieldTouched = () => {
        const { field } = this.props;
        let { touched } = this.props.form;
        touched[field.name] = true;
        this.props.form.setTouched(touched);
    }

    updateFormValue = (newValue) => {
        let value = [...newValue].map(item => {
            delete item.order;
            delete item.index;
            return item;
        })
        this.props.form.setFieldValue(this.props.field.name, value);
    }

    deleteItem(index) {
        this.setFieldTouched();
        const newValue = [...this.state.values];
        newValue.splice(index, 1);
        this.updateFormValue(_.cloneDeep(newValue));
        this.setState({
            values: newValue
        });
    }

    addItem = () => {
        this.setFieldTouched();
        let newValue =
            typeof this.state.values !== undefined
                ? [...this.state.values, { value: undefined, repeat: undefined, order: this.state.values.length, index: this.state.values.length }]
                : [{ value: undefined, repeat: undefined, order: 0, index: 0 }];
        this.updateFormValue(_.cloneDeep(newValue));
        this.setState({
            values: newValue
        });
    }

    changeValue = (value, index) => {
        this.setFieldTouched();
        const newValue = [...this.state.values];
        newValue[index]['value'] = parseInt(value);
        this.updateFormValue(_.cloneDeep(newValue));
        this.setState({
            values: newValue
        });
    }

    changeRepeat = (repeat, index) => {
        this.setFieldTouched();
        const newValue = [...this.state.values];
        newValue[index]['repeat'] = parseInt(repeat);
        this.updateFormValue(_.cloneDeep(newValue));
        this.setState({
            values: newValue
        });
    }

    moveDown = (index) => {
        let newValue = [...this.state.values];
        if (index < newValue.length - 1) {
            let element = newValue[index];
            newValue.splice(index, 1);
            newValue.splice(index + 1, 0, element);
            newValue.map((item, index) => {
                item.order = index;
                return item;
            })
            this.updateFormValue(_.cloneDeep(newValue));
            this.setState({
                values: newValue
            });
        }
    }

    moveUp = (index) => {
        if (index > 0) {
            let newValue = [...this.state.values];
            let element = newValue[index];
            newValue.splice(index, 1);
            newValue.splice(index - 1, 0, element);
            newValue.map((item, index) => {
                item.order = index;
                return item;
            })
            this.updateFormValue(_.cloneDeep(newValue));
            this.setState({
                values: newValue
            });
        }
    }

    render() {
        const fieldName = this.props.field.name;
        const errors =
            this.props.form.errors[fieldName] != "Field is required."
            || (this.props.isConfig && !this.props.disabled)
                ? this.props.form.errors[fieldName]
                : this.props.form.touched[fieldName] &&
                this.props.form.errors[fieldName];

        const errorMessageEl = errors && (
            <div className="input-error">
                {Array.isArray(errors) && errors.map((error, index) => {
                    if (typeof error === 'object') {
                        return Object.keys(error).map((objKey, objIndex) => {
                            return <span key={`${index}-${objIndex}`} className="input-error-message">{error[objKey]}</span>
                        })
                    } else {
                        return <span key={`${index}-single`} className="input-error-message">{error}</span>
                    }
                })}
                {!Array.isArray(errors) && (<span className="input-error-message">{errors}</span>)}
            </div>
        );

        const props = { ...this.props };
        delete props.decimal;

        const fieldProps = { ...this.props.field };
        delete fieldProps.value;

        return (
            <div id={this.props.givenid + "Input"}>
                <div
                    className={
                        "array-input input-group " +
                        (errors ? "input-group-error" : "")
                    }
                >
                    <button className="add-obj-button hidden-disabled" onClick={this.addItem}><i className="icon-plus-light"></i></button>
                    <div
                        style={{ padding: "0px 16px 3px 16px", height: "auto" }}
                        className="input"
                    >
                        {this.state.values == undefined ||
                            (this.state.values.length == 0 && (
                                <span
                                    style={{
                                        opacity: 0.7,
                                        color: "#ff396f",
                                        display: "flex",
                                        lineHeight: "40px",
                                        marginBottom: "-3px"
                                    }}
                                >
                                    No values set yet
                                </span>
                            ))}
                        {this.state.values !== undefined &&
                            this.state.values.length > 0 && (
                                <table className="array-table" cellSpacing="0" cellPadding="0">
                                    <thead>
                                        <tr>
                                            <th>Array Values</th>
                                            <th>Nº of Repetitions</th>
                                            <th className="hidden-disabled"></th>
                                            <th className="hidden-disabled"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.values.map((value, index) => {
                                            return (<tr key={index}>
                                                <td>
                                                    <input key={`${value.index}-value-${value.order}`} type="number" defaultValue={value.value} onChange={(event) => this.changeValue(event.currentTarget.value, index)} placeholder="Value" />
                                                </td>
                                                <td>
                                                    <input key={`${value.index}-repeat-${value.order}`} type="number" defaultValue={value.repeat} onChange={(event) => this.changeRepeat(event.currentTarget.value, index)} placeholder="Repetitions" />
                                                </td>
                                                <td className="hidden-disabled">
                                                    <div className="order">
                                                        <button
                                                            className="order-btn"
                                                            onClick={() => this.moveUp(index)}
                                                            disabled={index == 0}>
                                                            {index > 0 && <i className="icon-chevron-up-light"></i>}
                                                        </button>
                                                        <button
                                                            className="order-btn"
                                                            onClick={() => this.moveDown(index)}
                                                            disabled={index == this.state.values.length - 1}>
                                                            {index < this.state.values.length - 1 && <i className="icon-chevron-down-light"></i>}
                                                        </button>
                                                    </div>
                                                </td>
                                                <td className="hidden-disabled">
                                                    <button className="remove-obj-button" onClick={() => this.deleteItem(index)}><i className="icon-times-solid"></i></button>
                                                </td>
                                            </tr>)
                                        })}
                                    </tbody>
                                </table>
                            )}
                    </div>
                </div>
                {errorMessageEl}
            </div>
        );
    }
}
